import * as React from "react";
const SvgFiRrAlarmClock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-alarm-clock_svg__a)">
      <path d="M13 2.05V1a1 1 0 0 0-2 0v1.05a10.98 10.98 0 0 0-7.32 18.126A3.02 3.02 0 0 0 2 23a1 1 0 0 0 2 0 1.2 1.2 0 0 1 1.11-1.23 1 1 0 0 0 .2-.061 10.924 10.924 0 0 0 13.39 0q.087.04.182.064A1.2 1.2 0 0 1 20 23a1 1 0 1 0 2 0 3.02 3.02 0 0 0-1.681-2.824 10.981 10.981 0 0 0-7.32-18.125M3 13a9 9 0 1 1 9 9 9.01 9.01 0 0 1-9-9M19.215 0a1 1 0 1 0 0 2A2.59 2.59 0 0 1 22 4.5a1 1 0 0 0 2 0A4.6 4.6 0 0 0 19.215 0M2 4.5A2.59 2.59 0 0 1 4.785 2a1 1 0 0 0 0-2A4.6 4.6 0 0 0 0 4.5a1 1 0 0 0 2 0" />
      <path d="M13 11.586V7a1 1 0 0 0-2 0v5a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414z" />
    </g>
    <defs>
      <clipPath id="fi-rr-alarm-clock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAlarmClock;
